import { IonContent, IonIcon, IonPage } from '@ionic/react'
import React, { useContext } from 'react'
import styled from 'styled-components'
import { CustomSpacer, FooterButtons, StyleIonHeader, TextStyle } from '../../../../components'
import 'swiper/css'
import 'swiper/css/pagination'
import { DivideLine } from '../../../../components/atoms/divide'
import { chevronForwardOutline } from 'ionicons/icons'
import { StoresContext } from '../../../../provider/StoreProvider'
import moment from 'moment-timezone'
import { isLoaded, TradeHistoryListDone } from '../../../../common'

type Props = {
  tradeResult: TradeHistoryListDone
  onDismiss: () => void
}

export const TradeResultConfirmModal: React.FC<Props> = ({ tradeResult, onDismiss }) => {
  const { marketStore } = useContext(StoresContext)
  const productDetail = marketStore.productDetail

  const onVerifyTx = () => {
    window.open(`https://baobab.scope.klaytn.com/tx/${tradeResult.transaction.txId}`, '_blank')
  }

  const totalCost = (cost: number, count: number) => {
    const totalCost = Math.abs(count) * cost
    return Math.floor(totalCost).toLocaleString('ko-Kr')
  }

  return (
    <IonPage>
      <StyleIonHeader type={'MODAL'} title={''} onDismiss={onDismiss} />
      <IonContent>
        <SectionContainer>
          <TextStyle type="b_24">
            {tradeResult.tradeOrder.type === 'SELL' ? '매도 내역 확인서' : '매수 내역 확인서'}
          </TextStyle>
        </SectionContainer>
        <ImgWrap>
          <img
            src={tradeResult.transaction.certificateImgUrl}
            alt={tradeResult.orderSequence}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null
              currentTarget.src = '/img/thumbnail.svg'
            }}
          />
        </ImgWrap>
        {isLoaded(productDetail) && (
          <SectionContainer>
            <TextStyle type="b_16">트랜잭션 정보 </TextStyle>
            <CustomSpacer spacing="16px" />
            <BetweenWrap>
              <TextStyle type="r_13" color="gray400">
                거래일시
              </TextStyle>
              <TextStyle type="r_13">{`${moment(new Date(tradeResult.createdDate)).format(
                'YYYY.MM.DD HH:MM:SS',
              )}`}</TextStyle>
            </BetweenWrap>
            <DivideWrap>
              <DivideLine />
            </DivideWrap>
            <BetweenWrap>
              <TextStyle type="r_13" color="gray400">
                작품명
              </TextStyle>
              <TextStyle type="r_13">{productDetail.name}</TextStyle>
            </BetweenWrap>
            <BetweenWrap>
              <TextStyle type="r_13" color="gray400">
                작가명
              </TextStyle>
              <TextStyle type="r_13">{productDetail.artist}</TextStyle>
            </BetweenWrap>
            <DivideWrap>
              <DivideLine />
            </DivideWrap>
            <BetweenWrap>
              <TextStyle type="r_13" color="gray400">
                {tradeResult.tradeOrder.type === 'SELL' ? '매도' : '매수'} 수량
              </TextStyle>
              <TextStyle type="r_13">{Math.abs(tradeResult.count)} 개</TextStyle>
            </BetweenWrap>
            <DivideWrap>
              <DivideLine />
            </DivideWrap>
            <BetweenWrap>
              <TextStyle type="r_13" color="gray400">
                단가
              </TextStyle>
              <TextStyle type="r_13">{tradeResult.cost.toLocaleString()} 원</TextStyle>
            </BetweenWrap>
            <BetweenWrap>
              <TextStyle type="r_13" color="gray400">
                총 금액
              </TextStyle>
              <TextStyle type="r_13">{totalCost(tradeResult.tradeOrder.cost, tradeResult.count) ?? 0} 원</TextStyle>
            </BetweenWrap>
            <DivideWrap>
              <DivideLine />
            </DivideWrap>
            <BetweenWrap2 onClick={onVerifyTx}>
              <TextStyle type="r_13" color="gray400">
                트랜잭션 정보
              </TextStyle>
              <TxInfoContainer>
                <div className="tx_link">{tradeResult.transaction.txId}</div>
                <IonIcon color="medium" icon={chevronForwardOutline}></IonIcon>
              </TxInfoContainer>
            </BetweenWrap2>
          </SectionContainer>
        )}
        <MsgContainer>
          <TextStyle type="r_13" color="gray400">
            블록체인에 기록된 변조 불가능한 거래내역입니다.
          </TextStyle>
        </MsgContainer>
        <CustomSpacer spacing="30px" />
      </IonContent>
      <FooterButtons
        button={{
          color: 'dark',
          text: '닫기',
          onClick: onDismiss,
        }}
      />
    </IonPage>
  )
}

const ImgWrap = styled.div`
  overflow: auto;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
  img {
    max-width: 340px;
    height: 400px;
    object-fit: contains;
    border-radius: 10px;
    box-shadow: 1px 2px 3px 0px;
  }
`

const SectionContainer = styled.div`
  padding: 20px;
`

const BetweenWrap = styled.div`
  display: flex;
  justify-content: space-between;
`

const BetweenWrap2 = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`

const DivideWrap = styled.div`
  padding: 16px 0;
`

const TxInfoContainer = styled.div`
  max-width: 140px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  .tx_link {
    color: var(--ion-color-secondary_main);
    text-decoration: underline;
    text-decoration-color: var(--ion-color-secondary_main);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ion-icon {
    min-width: 16px;
  }
`

const MsgContainer = styled.div`
  width: 100%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`
